import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Popup } from "@progress/kendo-react-popup";
import styles from "pages/CaseFile/Casefile.module.scss";
import { MenuList } from "components/CaseFiles/CaseFilesHeader";
import { BsThreeDots } from "react-icons/bs";
import { LuFileSignature } from "react-icons/lu";
import { MdOutlinePreview } from "react-icons/md";
import { LiaDownloadSolid, LiaEditSolid, LiaReceiptSolid } from "react-icons/lia";
import { IoDuplicateOutline } from "react-icons/io5";
import { HiOutlineDocumentText } from "react-icons/hi2";
import { VscFilePdf } from "react-icons/vsc";
import { RiShareForward2Fill } from "react-icons/ri";
import { RiDeleteBin6Line } from "react-icons/ri";

const MenuCell = ({
  setViewActivity,
  setView,
  showDocumentFile,
  handleDownload,
  getDocumentEditorData,
  handleDuplicate,
  setShowShareDocument,
  setCurrentDoc,
  onDeleteClick,
  setESigning,
  setAddActivity,
  loaded,
  setLoaded,
  handleActivityRowClick,
  selectedState,
  setCurrentMatterForShare,
  activities,
  onAttachToChit,
  ...props
}) => {
  const { activityId, documentId, documentName, matterId, matterRef } =
    props.dataItem;
  const popupVisible = props.openMenuActivityId === activityId;
  const setPopupVisible = (next) => {
    const value = typeof next === "function" ? next(popupVisible) : next;
    if (value) {
      props.setOpenMenuActivityId?.(activityId);
    } else {
      props.setOpenMenuActivityId?.((current) =>
        current === activityId ? null : current,
      );
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const anchor = useRef();
  const setAnchorRef = (node) => {
    anchor.current = node;
    setAnchorEl(node);
  };
  const closeTimerRef = useRef(null);
  const scheduleClose = () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => {
      setPopupVisible(false);
      closeTimerRef.current = null;
    }, 200);
  };
  const cancelClose = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const selectedActivitiesWithDocs = React.useMemo(() => {
    const ids = Object.keys(selectedState || {}).filter((k) => selectedState[k]);
    return ids
      .map((id) => activities?.find((a) => a.activityId == id))
      .filter((a) => a && a.documentId && a.documentName);
  }, [selectedState, activities]);
  const canAttachToChit = selectedActivitiesWithDocs.length > 0;

  const handleMenuClick = (e) => {
    e.stopPropagation();
    if (popupVisible) {
      setPopupVisible(false);
      return;
    }
    const isSelected = selectedState[activityId];
    if (!isSelected) {
      props.setSelectedState({ [activityId]: true });
      props.setMultiSel(false);
      if (props.isDocViewerOpen) {
        props.showPaneFile(documentId);
      }
    }
    setPopupVisible(true);
  };

  useEffect(() => {
    const closePopup = (e) => {
      if (anchor.current && anchor.current.contains(e.target)) return;
      setPopupVisible(false);
    };

    document.addEventListener("click", closePopup);
    return () => {
      document.removeEventListener("click", closePopup);
    };
  }, []);

  return (
    <td
      onMouseLeave={() => {
        loaded && setLoaded(false);
      }}
    >
      <Popup
        show={popupVisible}
        anchor={anchorEl}
        appendTo={typeof document !== "undefined" ? document.body : undefined}
        popupClass={`${styles["popup-content"]} ${styles["menu-popup"]}`}
        anchorAlign={{ horizontal: "right", vertical: "center" }}
        popupAlign={{ horizontal: "left", vertical: "center" }}
        animate={false}
        style={{ zIndex: 10003 }}
      >
        <div
          className="mb-3"
          style={{ width: "80%", margin: "auto" }}
          onMouseEnter={cancelClose}
          onMouseLeave={scheduleClose}
        >
          <div className={styles["border-bottom"]}></div>
          <div className="flex flex-column mt-4 justify-start">
            <MenuList
              border={true}
              icon={<MdOutlinePreview role="button" size={22} color="black" />}
              name="View Activity"
              noMargins
              onClick={() => {
                if (handleActivityRowClick) {
                  handleActivityRowClick(props.dataItem);
                } else {
                  setAddActivity(true);
                  setViewActivity(props.dataItem);
                  setView(true);
                }
              }}
            />
            {documentId && documentName && (
              <>
                <MenuList
                  border={true}
                  noMargins
                  icon={
                    <HiOutlineDocumentText
                      role="button"
                      size={22}
                      color="black"
                    />
                  }
                  name="Preview Document"
                  onClick={() => showDocumentFile(documentId)}
                />
                <MenuList
                  noMargins
                  border={true}
                  name="Download"
                  icon={<LiaDownloadSolid role="button" size={22} />}
                  onClick={() => handleDownload(documentId)}
                />
                {canAttachToChit && (
                  <MenuList
                    noMargins
                    border={true}
                    name="Attach to Chit"
                    icon={<LiaReceiptSolid role="button" size={22} color="black" />}
                    onClick={() => {
                      const docs = selectedActivitiesWithDocs.map((a) => ({
                        documentId: a.documentId,
                        documentName: a.documentName,
                      }));
                      setPopupVisible(false);
                      onAttachToChit?.(docs);
                    }}
                  />
                )}
                {(documentName.includes(".docx") ||
                  documentName.includes(".doc")) && (
                  <MenuList
                    noMargins
                    border={true}
                    name="Edit"
                    icon={<LiaEditSolid role="button" size={22} />}
                    onClick={() => {
                      if (setCurrentMatterForShare && matterId) {
                        setCurrentMatterForShare({
                          matterId: matterId,
                          matterRef: matterRef,
                        });
                      }
                      getDocumentEditorData(documentId);
                    }}
                  />
                )}
                <MenuList
                  noMargins
                  border={true}
                  name="Duplicate"
                  icon={<IoDuplicateOutline role="button" size={22} />}
                  onClick={() =>
                    handleDuplicate(
                      props?.matterId ?? props.dataItem?.matterId,
                      props.dataItem,
                    )
                  }
                />
                {/* )} */}
                {!documentName?.includes(".pdf") && (
                  <MenuList
                    noMargins
                    border={true}
                    name="Download as PDF"
                    icon={<VscFilePdf role="button" size={22} />}
                    onClick={() => handleDownload(documentId, true)}
                  />
                )}

                <MenuList
                  noMargins
                  border={true}
                  icon={<RiShareForward2Fill role="button" size={20} />}
                  name="Share"
                  onClick={() => {
                    setShowShareDocument(true);
                    setCurrentDoc({
                      id: documentId,
                      name: documentName,
                    });
                    if (setCurrentMatterForShare && matterId) {
                      setCurrentMatterForShare({
                        matterId: matterId,
                        matterRef: matterRef,
                      });
                    }
                  }}
                />
              </>
            )}

            {documentId && documentName && (
              <MenuList
                border={true}
                noMargins
                icon={<LuFileSignature role="button" size={22} color="black" />}
                name="E Signing"
                onClick={() => {
                  setESigning(activityId);
                  if (setCurrentMatterForShare && matterId) {
                    setCurrentMatterForShare({
                      matterId: matterId,
                      matterRef: matterRef,
                    });
                  }
                }}
              />
            )}
            <MenuList
              noMargins
              border={false}
              name="Delete"
              icon={<RiDeleteBin6Line role="button" size={18} />}
              onClick={() => onDeleteClick?.(props.dataItem)}
            />
          </div>
        </div>
      </Popup>
      <div
        ref={setAnchorRef}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={handleMenuClick}
        onMouseEnter={cancelClose}
        onMouseLeave={scheduleClose}
        className={
          Object.keys(selectedState)[0] === activityId || popupVisible
            ? `d-flex gap-3 ${styles["menuTrigger"]}`
            : `activity-table-filters gap-3 ${styles["menuTrigger"]}`
        }
      >
        <BsThreeDots color="#323130" size={20} role="button" />
      </div>
    </td>
  );
};

export default MenuCell;
